import React from 'react';
import generateConditionLabel from '../Condition/generateConditionLabel';

function getLabelForTraceBackStep(step) {
  switch (step.type) {
    case 'module':
      return `Module: ${step.moduleName}`;
    case 'answer_to_question':
      return `${step.questionText} -> ${step.answerTitle}`;
    case 'conditional':
      return `IF ${generateConditionLabel(step.conditionalView.condition)}:`;
    case 'dxhx_pt_factor':
      return `DxHx Pt Factors: ${step.dxhxName}`;
    case 'sx_of_dxhx':
      return `Symptom of DxHx: DxHx="${step.dxhxName}" -> Symptom="${step.symptomName}"`;
    case 'rfv':
      return `RFV: ${step.rfvName}`;
    case 'request_for_medication':
      return `Request for medication: ${step.medicationName}`;
    case 'medication_usage':
      return `Medication usage: ${step.medicationName}`;
    case 'error':
      return `Error: ${step.error}`;
    case 'unused':
      return 'The following step is unused and can be ignored. Should be removed in next DB cleanup.';
    default:
      return `Unknown step type: ${step.type}`;
  }
}

function renderActionTraceBack(contentTraceItems) {
  const lastStep = contentTraceItems.at(-1);
  if (!lastStep) return null;
  const firstStepLabel = getLabelForTraceBackStep(lastStep);
  return (
    <ul key={firstStepLabel}>
      <li>
        {firstStepLabel}
        {renderActionTraceBack(contentTraceItems.slice(0, -1)) || ''}
      </li>
    </ul>
  );
}

export function renderModuleTraceBack(intakePlans, contentTraces) {
  return (
    <div>
      <h3>Intake Plans</h3>
      <ul>
        {intakePlans?.map((intakePlan) => (
          <li key={intakePlan.id}>
            {intakePlan.referenceCode}
            {' '}
            {intakePlan.description}
          </li>
        ))}
      </ul>
      <div>
        <h3>Actions</h3>
        {contentTraces?.map((contentTrace) => renderActionTraceBack(contentTrace.steps))}
      </div>
    </div>
  );
}

// Helper that creates a render function for WhereButton
export function createContentTraceRenderer(data) {
  const { intakePlans, contentTrace } = data;
  return renderModuleTraceBack(intakePlans, contentTrace);
}

// Creates a whereService callback that fetches and renders content traces
export function createContentTraceWhereService(apiCall) {
  return async () => {
    const response = await apiCall();
    if (!response.data) {
      throw new Error(`WhereResponse was ${response}`);
    }
    const { intakePlans, contentTrace } = response.data;
    return renderModuleTraceBack(intakePlans, contentTrace);
  };
}
